import { from, of, combineLatest, timer, merge, EMPTY, animationFrames, interval } from 'rxjs'
import { map, filter, share, switchMap, mergeMap, catchError, startWith, debounceTime, takeWhile, delay, tap, scan, concatMap, take, takeUntil, withLatestFrom, finalize, pairwise, throttleTime } from 'rxjs/operators'
import Dispatch from '../Dispatcher'

let length = 1000000
Dispatch.getState('view.songLength')
  .subscribe(e => {length = e})

export default combineLatest(
  Dispatch.getState('view.playing'), 
  Dispatch.getAction('scrubClock')
    .pipe(
      startWith(0)
    ), 
  Dispatch.getState('view.elapsed')
)
//pause, start, scrub
    .pipe(
      switchMap(e => e[0] ? animationFrames()
        .pipe(
          //throttleTime(10),
          map(f => f.timestamp),
          pairwise(),
          withLatestFrom(Dispatch.getState('view.speed')),
          map(([[prev, next], speed]) => (next - prev) * speed),
          scan((acc, next) => acc + next, 0),
          withLatestFrom(Dispatch.getState('view.elapsed')),


          map(f => f[0] + f[1]),
					takeUntil(Dispatch.getAction('pauseClock')),
          takeWhile(e => e < length)

          //finalize((e) => console.log(e))//Dispatch.nextState('view.elapsedTime', ))
          //withLatestFrom(START TIME)
        )
        :
        of(e[2])
      ),
      share()
    )

    // combineLatest(Dispatch.getState('view.playing'), Dispatch.getState('view.elapsed'))
    //       .pipe(
    //         filter(e => e[0] === false),
    //         map(e => e[1])
    //       )
// const clock$ = animationFrames()
//   .pipe(
//     map(e => {
//       return Date.now() }),
//     pairwise(),
//     map(([prev, next]) => next - prev),
//     share()
//   )

// export const elapsedTime = merge(of(1), 
//   Dispatch.getAction('start')
//       .pipe(
//         //withLatestFrom(Dispatch.getState('Textbox.startTime').pipe(map(e => parseInt(e)))),
//         //map(e => e[1])
//         map(e => 0)
//       )
//   )
//   .pipe(
//     switchMap(startTime => merge( 
//       of(true), 
//       Dispatch.getAction('unpause')
//         .pipe(map(e => true)),
//       Dispatch.getAction('pause')
//         .pipe(map(e => false))
//       )
//       .pipe(
//         switchMap(e => e ? clock$ : of(0)),
//         scan((acc, next) => acc + next, startTime),
//         startWith(0)
//       ),
//     )
//   ) 